module.exports = __webpack_public_path__ + "img/noMsgImg.2b9b7ba0.png";